import React from 'react';
import { Box} from '@mui/material';
import ServiceHistory from '../../components/administration/serviceOrders/ServiceHistory';

const ServicioHistorialPage = () => {

    return (
        <Box sx={{ p: 2 }}>
            <ServiceHistory
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de servicio Historial:', newOrder);
                }}
            />
        </Box>
    );
};

export default ServicioHistorialPage;